export const registerTagmanagerEvent = (eventName: string, variables?: EventVariables) => {
  const dataLayerKey = 'dataLayer';
  const dataLayer = window[dataLayerKey] || [];

  dataLayer.push({
    event: eventName,
    ...(variables || {}),
  });
};

export interface EventVariables {};

export enum TagManagerEvent {
  START_SIMULATE = 'startSimulate',
};